import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ViewerErrorCommunicatorService {
  private viewerErrorSubject = new BehaviorSubject<string>(null);

  public viewerErrorSubject$ = this.viewerErrorSubject.asObservable();

  getLastError(): string {
    return this.viewerErrorSubject.getValue();
  }

  setViewerError(message: string) {
    this.viewerErrorSubject.next(message);
  }
}
